<template>
  <div class="orderdetail">
    <cube-page type="orderdetail-view" title="订单详情">
      <div slot="content">
        <div class="box-main">
          <div class="box" v-if="reservation">
            <h3>团队名称：{{ reservation.team_name || '暂无' }}</h3>
            <div class="list">
              <div class="list-item">
                <span>出团日期：</span>
                <span>{{ reservation.start_time || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>完团日期：</span>
                <span>{{ reservation.end_time || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>天数：</span>
                <span>{{ reservation.play_days || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>人数：</span>
                <span>{{ reservation.team_number || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>类型：</span>
                <span>{{ reservation.team_type_text || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>职级：</span>
                <span>{{ reservation.guide_rank_text || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>性别：</span>
                <span>{{ reservation.gender_text || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>语种：</span>
                <span>{{ reservation.lang_text || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>擅长：</span>
                <span>{{ reservation.skill_text || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>价格：</span>
                <span>{{ reservation.total_price || '暂无' }}</span>
              </div>
              <div class="list-item" style="display: flex;">
                <span>行程：</span>
                <span v-html="reservation.trip_text || '暂无'"></span>
              </div>
              <div class="list-item">
                <span>状态：</span>
                <span style="color: red">{{ reservation.status_text || '暂无' }}</span>
              </div>
              <div class="list-item" v-if="reservation.guide_eval != null">
                <span>导游评价：</span>
                <span v-html="reservation.guide_eval || '暂无'"></span>
              </div>
              <div class="list-item" v-if="reservation.dtd_eval != null">
                <span>分销商评价：</span>
                <span v-html="reservation.dtd_eval || '暂无'"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-btn" v-if="btnstatus">
          <van-button type="info" :loading="loading" @click="handleStatus">{{ btnstatus }}</van-button>
        </div>
        <van-overlay :show="showMemo" @click="showMemo = false">
          <div class="wrapper" @click.stop>
            <div class="block">
              <h4>评价</h4>
              <van-field v-model="message" rows="2" :autosize="autosize" label="填写评价" type="textarea" maxlength="100"
                placeholder="请输入评价" show-word-limit clearable />
              <div class="btn">
                <van-button type="primary" size="small" plain @click="showMemo = false">关闭</van-button>
                <van-button type="primary" size="small" @click="confirmbtn">确认</van-button>
              </div>
            </div>
          </div>
        </van-overlay>
      </div>
    </cube-page>
  </div>
</template>

<script>
import CubePage from '../../TP/cube-page.vue'
import * as util from '@/utils/network'
import {
  Toast,
} from 'vant';

export default {
  components: {
    CubePage,
  },
  data() {
    return {
      reservation: null,
      showMemo: false,
      message: '',
      onlyId: '',
      autosize: {
        minHeight: 100
      },
      loading: false,
      btnstatus: ''
    };
  },
  mounted() {
    this.onlyId = this.$route.query.id;
    this.getData(this.onlyId)
  },
  methods: {
    getData(id) {
      let url = "/addons/litestore/api.guide/order";
      //这里直接调用网络接口
      console.log(id);
      util.get(url, { id }, (result) => {
        console.log(result);
        if (result.code == 1) {
          this.reservation = result.data;
          let { status } = result.data
          if (status == '13') {
            this.btnstatus = '出团'
          }
          if (status == '14') {
            this.btnstatus = '完团'
          }
          if (status == '15') {
            this.btnstatus = '评价'
          }
        }
      });
    },
    // 点击出团/完团
    handleStatus() {
      this.loading = true;
      if (this.btnstatus !== '评价') {
        this.$dialog.confirm({
          title: '提示',
          message: `确认进行${this.btnstatus}操作吗？`
        }).then(() => {
          this.ajaxPost();
        }).catch(() => { });
      } else {
        this.showMemo = true
      }

      setTimeout(() => {
        this.loading = false;
      }, 2000)
    },
    // 评价
    confirmbtn() {
      let message = this.message;
      if (!message) {
        return Toast('评价不能为空')
      }
      this.showMemo = false;
      this.ajaxPost();
    },
    ajaxPost() {
      let url = '/addons/litestore/api.guide/operate';
      let params = {
        id: this.onlyId,
        status: this.reservation.status,
      }
      if (this.btnstatus == '评价') {
        params.guider_emo = this.message
      }
      console.log(params);
      util.post(url, params, (result) => {
        Toast(result.msg)
        if (result.code == 1) {
          this.getData(this.onlyId)
          this.loading = false;
        }
      });
    },
  },
}
</script>
<style lang="less" scoped="scoped">
.box-main {
  padding: 20px;

  .box {
    padding: 10px 0;
    background: #fff;
    border-radius: 8px;

    h3 {
      border-bottom: 1px solid #eee;
      padding: 0 15px 10px;
    }

    .list {
      padding: 15px 15px 0;
      display: flex;
      flex-flow: wrap;
      font-size: 14px;

      .list-item {
        width: 100%;
        margin-bottom: 10px;

        span:first-child {
          color: #666;
        }
      }

      .max {
        width: 100%;
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
}

.footer-btn {
  position: fixed;
  left: 5%;
  bottom: 40px;
  width: 90%;
  display: flex;
  justify-content: space-between;

  .van-button {
    width: 100%;
    border-radius: 8px;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .block {
    width: 80%;
    min-height: 200px;
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;

    h4 {
      text-align: center;
      margin-bottom: 20px;
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 15px;

      button {
        margin-left: 15px;
        padding: 0 30px;
        border-radius: 4px;
      }
    }
  }
}
</style>
